import Button from "../button";
import { Calendar, ExternalLink, Import, LoopIcon } from "../../assets/icons";
import useSlideOver from "../slideOver/useSlideOver";
import StyledInput from "../styledInput/StyledInput";
import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import { forceDateToUtc0, datePeriodShort } from "../../utils/Date";
registerLocale("fr", fr);

const NavBarHourlyTracking = ({
  dateStart,
  setDateStart,
  dateEnd,
  setDateEnd,
  companySelected,
  setCompanySelected,
  companyList,
  setCompanyList,
  interimAgencyList,
  setInterimAgencyList,
  interimAgencySelected,
  setInterimAgencySelected,
  interimSectorList,
  setInterimSectorList,
  interimSectorSelected,
  setInterimSectorSelected,
  search,
  setSearch,
  missionStatusSelected,
  setMissionStatusSelected,
  missionStatusList,
  setMissionStatusList,
}) => {
  const { toggleSlideOver } = useSlideOver();
  const isShowImportExport = [225, 215, 210].includes(
    Number(localStorage.getItem("rUser")) || 0,
  );

  const todayStr = new Date().toISOString().split("T")[0];
  const isToday =
    dateStart?.toISOString().split("T")[0] === todayStr &&
    dateEnd?.toISOString().split("T")[0] === todayStr;

  const isSingleDay =
    dateStart &&
    dateEnd &&
    dateStart.toISOString().split("T")[0] === dateEnd.toISOString().split("T")[0];

  const periodLabel = dateStart && dateEnd && !isSingleDay
    ? datePeriodShort(dateStart, dateEnd)
    : null;

  const updateCompaniesList = (updatedCompany) => {
    const updatedCompanies = [];
    for (let i = 0; i < companyList.length; i++) {
      for (let j = 0; j < updatedCompany.length; j++) {
        if (companyList[i].idCompany === updatedCompany[j].value) {
          updatedCompanies.push({
            ...companyList[i],
            checked: updatedCompany[j].checked,
          });
        }
      }
    }
    setCompanyList(updatedCompanies);
    setCompanySelected({
      idCompany: updatedCompanies.find((company) => company.checked).idCompany,
      name: updatedCompanies.find((company) => company.checked).name,
      syncDate: updatedCompanies.find((company) => company.checked).syncDate,
      badgerName: updatedCompanies.find((company) => company.checked)
        .badgerName,
    });
  };

  const updateInterimAgenciesList = (updatedInterimAgency) => {
    const updatedInterimAgencies = [];

    for (let i = 0; i < interimAgencyList.length; i++) {
      for (let j = 0; j < updatedInterimAgency.length; j++) {
        if (interimAgencyList[i].name === updatedInterimAgency[j].value) {
          updatedInterimAgencies.push({
            ...interimAgencyList[i],
            checked: updatedInterimAgency[j].checked,
          });
        }
      }
    }

    setInterimAgencyList(updatedInterimAgencies);

    const selectedInterimAgencies = updatedInterimAgencies.filter(
      (interimAgency) => interimAgency.checked,
    );

    setInterimAgencySelected(selectedInterimAgencies);
  };

  const updateInterimSectorsList = (updatedInterimSector) => {
    const updatedInterimSectors = [];

    for (let i = 0; i < interimSectorList.length; i++) {
      for (let j = 0; j < updatedInterimSector.length; j++) {
        if (interimSectorList[i].name === updatedInterimSector[j].value) {
          updatedInterimSectors.push({
            ...interimSectorList[i],
            checked: updatedInterimSector[j].checked,
          });
        }
      }
    }

    setInterimSectorList(updatedInterimSectors);

    const selectedInterimSectors = updatedInterimSectors.filter(
      (interimSector) => interimSector.checked,
    );

    setInterimSectorSelected(selectedInterimSectors);
  };

  const updateMissionStatusList = (updateMissionStatus) => {
    const updatedMissionsStatus = [];

    for (let i = 0; i < missionStatusList.length; i++) {
      for (let j = 0; j < updateMissionStatus.length; j++) {
        if (missionStatusList[i].type === updateMissionStatus[j].value) {
          updatedMissionsStatus.push({
            ...missionStatusList[i],
            checked: updateMissionStatus[j].checked,
          });
        }
      }
    }

    setMissionStatusList(updatedMissionsStatus);

    const selectedMissionStatus = updatedMissionsStatus.filter(
      (missionStatus) => missionStatus.checked,
    );

    setMissionStatusSelected(selectedMissionStatus);
  };

  const exportMissions = () => {
    if (companySelected) {
      toggleSlideOver("export_missions");
    }
  };

  return (
    <nav className={"w-full flex justify-between items-center min-h-[45px]"}>
      <div className={"flex gap-2 items-center text-sm"}>
        <Button
          color={isToday ? "DISABLED" : "SECONDARY"}
          size={"SMI"}
          onClick={!isToday ? () => { setDateStart(new Date()); setDateEnd(new Date()); } : undefined}
        >
          Aujourd'hui
        </Button>
        <div>
          <DatePicker
            selectsRange
            startDate={forceDateToUtc0(dateStart)}
            endDate={dateEnd ? forceDateToUtc0(dateEnd) : null}
            onChange={([start, end]) => {
              // Normalize to noon to prevent timezone offset from shifting to previous day
              if (start) {
                setDateStart(new Date(start.getFullYear(), start.getMonth(), start.getDate(), 12, 0, 0, 0));
              }
              if (end) {
                setDateEnd(new Date(end.getFullYear(), end.getMonth(), end.getDate(), 12, 0, 0, 0));
              } else {
                setDateEnd(null);
              }
            }}
            dateFormat="dd/MM/yyyy"
            locale="fr"
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            popperPlacement="bottom"
            className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-center"
            customInput={
              <Button color={periodLabel ? "PRIMARY" : "SECONDARY"} size={"SMI"}>
                <div className={"flex gap-1.5 items-center"}>
                  <Calendar wh={16} color={periodLabel ? "#FFFFFF" : "#374151"} />
                  {periodLabel && (
                    <span className={"text-sm whitespace-nowrap"}>{periodLabel}</span>
                  )}
                </div>
              </Button>
            }
          />
        </div>
        {companyList.length > 1 && (
          <div className={"max-w-[150px] text-sm"}>
            <StyledInput
              type={"selectMultipleRadio"}
              value={companySelected?.name || ""}
              list={companyList.map((company) => {
                return {
                  value: company.idCompany,
                  label: company.name,
                  checked: company.checked,
                };
              })}
              onChange={(updatedCompany) => updateCompaniesList(updatedCompany)}
              isSearchable={true}
            />
          </div>
        )}
        {interimAgencyList.length > 1 && (
          <div className={"max-w-[150px] text-sm"}>
            <StyledInput
              type={"selectMultipleCheckbox"}
              value={
                interimAgencySelected.length > 0
                  ? interimAgencySelected
                      .map((agency) => agency.name)
                      .join(", ")
                  : "Agence"
              }
              list={interimAgencyList.map((interimAgency) => {
                return {
                  value: interimAgency.name,
                  label: interimAgency.name,
                  checked: interimAgency.checked,
                };
              })}
              onChange={(updatedInterimAgency) =>
                updateInterimAgenciesList(updatedInterimAgency)
              }
              isSearchable={true}
            />
          </div>
        )}
        {interimSectorList.length > 1 && (
          <div className={"max-w-[150px] text-sm"}>
            <StyledInput
              type={"selectMultipleCheckbox"}
              value={
                interimSectorSelected.length > 0
                  ? interimSectorSelected
                      .map((sector) => sector.name)
                      .join(", ")
                  : "Secteurs"
              }
              list={interimSectorList.map((interimSector) => {
                return {
                  value: interimSector.name,
                  label: interimSector.name,
                  checked: interimSector.checked,
                };
              })}
              onChange={(updatedInterimSector) =>
                updateInterimSectorsList(updatedInterimSector)
              }
              isSearchable={true}
            />
          </div>
        )}
        {missionStatusList.length > 1 && (
          <div className={"max-w-[150px] text-sm"}>
            <StyledInput
              type={"selectMultipleCheckbox"}
              value={
                missionStatusSelected.length > 0
                  ? missionStatusSelected
                      .map((status) => status.name)
                      .join(", ")
                  : "État"
              }
              list={missionStatusList.map((missionStatus) => {
                return {
                  value: missionStatus.type,
                  label: missionStatus.name,
                  checked: missionStatus.checked,
                };
              })}
              onChange={(updatedMissionStatus) =>
                updateMissionStatusList(updatedMissionStatus)
              }
            />
          </div>
        )}
        <div className={"w-[213px] text-sm"}>
          <StyledInput
            type={"text"}
            placeholder={"Rechercher..."}
            imgFront={<LoopIcon wh={16} color={"#6B7280"} />}
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>
      {isShowImportExport && (
        <div className={"flex gap-2 items-center"}>
          <Button
            color={"PRIMARY"}
            size={"SMI"}
            onClick={() => toggleSlideOver("import_missions")}
          >
            <div className={"flex gap-1 items-center"}>
              <Import wh={16} color={"#FFFFFF"} />
              Importer
            </div>
          </Button>
          {companySelected ? (
            <div className={"flex flex-col"}>
              <div className={"flex justify-end"}>
                <div className={"w-fit"}>
                  <Button
                    color={"SECONDARY"}
                    size={"SM"}
                    onClick={exportMissions}
                  >
                    <div className={"flex gap-1 items-center"}>
                      <ExternalLink wh={16} color={"#374151"} />
                      Export
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <Button color={"DISABLED"} size={"SMI"}>
              <div className={"flex gap-1 items-center"}>
                <ExternalLink wh={16} color={"#9CA3AF"} />
                Export
              </div>
            </Button>
          )}
        </div>
      )}
    </nav>
  );
};

export default NavBarHourlyTracking;
